<template>
    <section>
        <div class="home-actions">
            <router-link :to="protokolErfassen">
                <button>Neues Protokoll</button>
            </router-link>
            <router-link :to="bestandsaufnahmeErfassen">
                <button>Bestandsaufnahme</button>
            </router-link>
            <router-link :to="protokelAnschauen('Abgeschlossen')">
                <button>Abgeschlossene Protokolle</button>
            </router-link>
            <router-link :to="protokelAnschauen('In Bearbeitung')">
                <button>Protokolle in Bearbeitung</button>
            </router-link>
            <router-link :to="protokelAnschauen('alle')">
                <button>Alle Protokolle</button>
            </router-link>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'myHome',
        data() {
            return {
                userName: '',
            };
        },
        computed: {
            protokolErfassen() {
                return {name: 'protokolerfassen'};
            },
            bestandsaufnahmeErfassen() {
                return {
                    name: 'protokolerfassen',
                    query: { lockedType: 'Bestandsaufnahme' },
                };
            },
        },
        methods: {
            protokelAnschauen(listName) {
                return {
                    name: 'prtokollist',
                    params: {
                        listType: listName,
                    },
                };
            },
        },
    };
</script>

<style scoped>
    section {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: calc(100vh - var(--app-header-height) - var(--app-footer-height));
        height: calc(100dvh - var(--app-header-height) - var(--app-footer-height));
        margin-top: var(--app-header-height);
        padding: 0.85rem 1.5rem;
        box-sizing: border-box;
        overflow: hidden;
    }

    .home-actions {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        width: 100%;
        max-width: 28rem;
        height: 100%;
        min-height: 0;
        gap: 0.75rem;
    }

    .home-actions a {
        display: flex;
        flex: 1 1 0;
        width: 100%;
        min-height: 0;
        margin: 0;
        text-decoration: none;
        color: inherit;
    }

    .home-actions button {
        width: 100%;
        min-width: unset;
        min-height: 0;
        height: 100%;
        padding: 0.8rem 1.25rem;
        background-color: #1c335a;
        font-size: clamp(1.05rem, 2.4vh, 1.35rem);
        color: white;
        border-radius: 14px;
        border: none;
        cursor: pointer;
    }

    .home-actions button:hover {
        box-shadow: 0 0 5px 5px #315492;
        background-color: white;
        color: #264271;
        transition: all 0.2s ease-in-out;
    }

    @media (min-width: 769px) {
        .home-actions {
            max-width: 42rem;
            gap: clamp(0.65rem, 1.4vh, 1.1rem);
        }

        .home-actions button {
            padding: clamp(0.75rem, 2vh, 1.6rem) 2.25rem;
            font-size: clamp(1.35rem, 3.2vh, 2rem);
            border-radius: 22px;
        }
    }

    @media (min-width: 1200px) {
        .home-actions {
            max-width: 48rem;
            gap: clamp(0.75rem, 1.6vh, 1.25rem);
        }

        .home-actions button {
            padding: clamp(0.85rem, 2.2vh, 2rem) 2.5rem;
            font-size: clamp(1.5rem, 3.6vh, 2.2rem);
            border-radius: 24px;
        }
    }

    @media (max-width: 768px) {
        section {
            padding: 0.85rem 1rem;
        }

        .home-actions {
            max-width: min(28rem, 92vw);
            gap: 0.75rem;
        }

        .home-actions button {
            font-size: clamp(1.2rem, 3.2vh, 1.45rem);
            padding: clamp(0.7rem, 1.8vh, 1.1rem) 1.25rem;
            border-radius: 18px;
        }
    }

    /* Short viewports (phone landscape): scroll inside the area above the fixed footer */
    @media (max-height: 500px) {
        section {
            /* Keep fixed height so overflow scrolls above the footer, not under it */
            height: calc(100vh - var(--app-header-height) - var(--app-footer-height));
            height: calc(100dvh - var(--app-header-height) - var(--app-footer-height));
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            justify-content: flex-start;
            padding-bottom: 0.5rem;
        }

        .home-actions {
            height: auto;
            flex: 0 0 auto;
            gap: 0.5rem;
            padding-bottom: 0.25rem;
        }

        .home-actions a {
            flex: 0 0 auto;
            min-height: unset;
        }

        .home-actions button {
            height: auto;
            min-height: 2.75rem;
            font-size: 1.1rem;
            padding: 0.55rem 1.25rem;
            border-radius: 14px;
        }
    }
</style>
